import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'
import { FEATURE_FLAG_FILE } from '../config'

export const FEATURE_FLAG_REQUEST = 'FEATURE_FLAG_REQUEST'
export const FEATURE_FLAG_SUCCESS = 'FEATURE_FLAG_SUCCESS'
export const FEATURE_FLAG_FAILURE = 'FEATURE_FLAG_FAILURE'

export function fetchFeatureFlag() {
  return {
    [CALL_API]: {
      endpoint: '/' + FEATURE_FLAG_FILE,
      types: [FEATURE_FLAG_REQUEST, FEATURE_FLAG_SUCCESS, FEATURE_FLAG_FAILURE],
      method: 'GET',
      tokenType: API_JWT_TOKEN_NAME,
      isEndpointAbs: true,
    },
  }
}
